

/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    debounce,
    FormControl,
    InputAdornment,
    Menu,
    MenuItem,
    Select,
    Stack,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Typography,
    useMediaQuery,
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AddIcon from '@mui/icons-material/Add';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Container from '../../components/container/Container';
import SectionHeader from '../../components/sectionheader/SectionHeader';
import eventicon from '../../assets/icons/eventicon.svg';
import searchIcon from '../../assets/icons/searchicon.svg';
import CustomTableContainer from '../../components/table-container/CustomTableContainer';
import Pagination from '../../components/pagination';
import getEventsDetailsData from '../../services/events/getEventsDetails';
import { useAuthContext } from '../../auth/useAuthContext';
import NoData from '../../components/no-data/NoData';
import event_no_data from '../../assets/icons/event_no_data.svg';
import LoadingInPage from '../../components/loading-screen/LoadingInPage';
import EventsFilter from './events-filter';
import Radiobutton_dialog from './radiobutton_dialog';
import TruncateText from '../../components/truncate_text/TruncateText';
import getSelfVendorEventsDetails from 'src/services/events/getSelfVendorEventsDetails';

const heading = {
    icon: eventicon,
    label: 'Events',
};

const getStatusDotStyle = {
    height: '6px',
    width: '6px',
    borderRadius: '50%',
    display: 'inline-block',
};

const getStatusTextWithColor = (status) => {
    let text = '';
    let color = '';

    switch (status) {
        case 0:
            text = 'Live';
            color = '#4CAF50';
            break;
        case 1:
            text = 'Completed';
            color = '#FF2626';
            break;
        default:
            text = 'Upcoming';
            color = '#F38505';
            break;
    }

    return (
        <div>
            <span style={{ ...getStatusDotStyle, backgroundColor: color }} />
            <span style={{ marginLeft: '6px', color }}>{text}</span>
        </div>
    );
};

const getStatusTextWithColor2 = (status) => {
    let text = "";
    let color = "";

    switch (status) {
        case "approved":
            text = "Approved";
            color = "#4CAF50";
            break;
        case "rejected":
            text = "Rejected";
            color = "#FF2626";
            break;
        case "needs_improvement":
            text = "Needs Improvement";
            color = "#f38405ff";
            break;
        default:
            text = "Pending Approval";
            color = "#F38505";
            break;
    }

    return (
        <div>
            <span style={{ ...getStatusDotStyle, backgroundColor: color }}></span>
            <span style={{ marginLeft: "6px", color }}>{text}</span>
        </div>
    );
};

const headCells = [
    { id: 'vender_name', label: 'Partner Name', width: 170 },
    { id: 'tracking_id', label: 'Event ID', width: 170 },
    { id: 'name', label: 'Event Name', width: 200 },
    {
        id: 'Event_capacity',
        label: 'Event Capacity',

        width: 240,
    },
    { id: 'event_start', label: 'Event Start', width: 230 },
    { id: 'event_end', label: 'Event End', width: 230 },
    { id: 'event_type', label: 'Event Type', width: 250 },
    { id: 'status', label: 'Event Status', width: 250 },
    { id: 'actions', label: 'Actions', width: 150 },
    // { id: 'update', label: 'Update', width: 150 },
];

const RequestEvent = () => {
    const { user, logout } = useAuthContext();
    const matches = useMediaQuery('(max-width:600px)');
    const [page, setPage] = useState(0);
    const [tabValue, setTabValue] = useState(0);
    const [page_size, setPage_size] = useState(15);
    const [totalPages, setTotalPages] = useState(0);
    const [total_records, setTotal_records] = useState(null);
    const [Loading, setLoading] = useState(true);
    const [events, setEvents] = useState([]);
    const [activeTab, setActiveTab] = useState(null);
    const [search, setSearch] = useState('');
    const [createEventPopup, setCreateEventPopup] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [tabCounts, setTabCounts] = useState({
        live: 0,
        upcoming: 0,
        completed: 0,
    });
    const [selectedVendors, setSelectedVendors] = useState([]);

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [selectedItems, setSelectedItems] = useState({
        eventCapacity: {
            belowFifty: false,
            fiftyToHundred: false,
            aboveHundred: false,
        },
    });
    const [filteranchorEl, setFilteranchorEl] = useState(null);
    const [packageTime, setPackageTime] = useState({
        validFrom: '',
        validTill: '',
    });
    const navigate = useNavigate();

    const handlePageSize = (event) => {
        setPage(0);
        setPage_size(event.target.value);
    };

    const handleEventDetails = (id, handle, eventTypeHandle, vendorID) => {
        navigate(`/dashboard/events/view/${handle}`, {
            state: { handle, eventTypeHandle, vendorID },
        });
    };

    const handleCancel = () => {
        setCreateEventPopup(false);
    };

    const eventFilterData = {
        capacity_from: '',
        capacity_to: '',
        event_from_date: packageTime?.validFrom === 'Invalid Date' ? '' : packageTime?.validFrom,
        event_till_date: packageTime?.validTill === 'Invalid Date' ? '' : packageTime?.validTill,
        vendor_id: selectedVendors.join(','),
    };

    if (
        selectedItems?.eventCapacity?.belowFifty &&
        selectedItems?.eventCapacity?.fiftyToHundred &&
        !selectedItems?.eventCapacity?.aboveHundred
    ) {
        eventFilterData.capacity_from = 0;
        eventFilterData.capacity_to = 100;
    }
    // 2) if user selects 0-50 and 100-aboveHundred
    else if (
        selectedItems?.eventCapacity?.belowFifty &&
        selectedItems?.eventCapacity?.aboveHundred &&
        !selectedItems?.eventCapacity?.fiftyToHundred
    ) {
        eventFilterData.capacity_from = 0;
        eventFilterData.capacity_to = 1000;
    }
    // 3) if user selects 50-100 and 100-aboveHundred
    else if (
        selectedItems?.eventCapacity?.fiftyToHundred &&
        selectedItems?.eventCapacity?.aboveHundred &&
        !selectedItems?.eventCapacity?.belowFifty
    ) {
        eventFilterData.capacity_from = 50;
        eventFilterData.capacity_to = 1000;
    } else if (
        selectedItems?.eventCapacity?.belowFifty &&
        selectedItems?.eventCapacity?.fiftyToHundred &&
        selectedItems?.eventCapacity?.aboveHundred
    ) {
        eventFilterData.capacity_from = 0;
        eventFilterData.capacity_to = 1000;
    } else if (
        selectedItems?.eventCapacity?.belowFifty &&
        !selectedItems?.eventCapacity?.fiftyToHundred &&
        !selectedItems?.eventCapacity?.aboveHundred
    ) {
        eventFilterData.capacity_from = 0;
        eventFilterData.capacity_to = 50;
    } else if (
        selectedItems?.eventCapacity?.fiftyToHundred &&
        !selectedItems?.eventCapacity?.aboveHundred &&
        !selectedItems?.eventCapacity?.belowFifty
    ) {
        eventFilterData.capacity_from = 50;
        eventFilterData.capacity_to = 100;
    }

    // 7) if user selects 100-aboveHundred
    else if (
        selectedItems?.eventCapacity?.aboveHundred &&
        !selectedItems?.eventCapacity?.belowFifty &&
        !selectedItems?.eventCapacity?.fiftyToHundred
    ) {
        eventFilterData.capacity_from = 100;
        eventFilterData.capacity_to = 1000;
    }
    const [status, setStatus] = useState("")

    const getData = async (searchText) => {
        const data = await getSelfVendorEventsDetails(
            user,
            tabValue == 2 ? 0 : tabValue == 0 ? 2 : 1,
            searchText,
            page,
            page_size,
            eventFilterData,
            status
        );

        const isActiveTab = data?.active_tab;
        if (isActiveTab >= 0) {
            setActiveTab(isActiveTab);
        }
        setTotalPages(data?.totalPages);
        setTotal_records(data?.total_records);
        setLoading(false);
        setEvents(data?._payload);
    };

    useEffect(() => {
        setLoading(true);
        if (user) {
            getData();
        }
    }, [user, page, page_size, selectedVendors, selectedItems, packageTime, tabValue, status]);




    const handleSearchDebounce = debounce((searchText) => {
        getData(searchText);
        setSearch(searchText);
    }, 500);

    const handleSearch = (e) => {
        setPage(0);

        const searchText = e.target.value;
        if (!searchText?.includes('\\') && /^[a-zA-Z 0-9!@#$%^&_:;<>,."/~\\-]*$/.test(searchText)) {
            handleSearchDebounce(searchText);
        }
    };



    return (
        <Container>
            <Stack spacing={3}>
                <Stack width="100%" spacing={2}>
                    <SectionHeader icon={heading?.icon} heading={"Event Review & Approval"} />
                    <Stack
                        width="100%"
                        direction="row"
                        justifyContent="space-between"
                        flexWrap="wrap"
                        gap="8px"
                    >
                        <Stack
                            width="100%"
                            maxWidth={{ xs: '220px', sm: '400px' }}
                            direction="row"
                            alignItems="center"
                            flexWrap="wrap"
                            gap={1}
                        >
                            <TextField
                                fullWidth
                                id="Search"
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                                backgroundColor="#FFFFFF"
                                onChange={handleSearch}
                                sx={{
                                    maxWidth: { xs: '200px', md: '236px', lg: '256px' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#7635DC',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#7635DC',
                                    },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Box
                                                component="img"
                                                src={searchIcon}
                                                alt="Search Icon"
                                                sx={{
                                                    width: 26,
                                                    height: 26,
                                                }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                        </Stack>
                        <Select
                            displayEmpty
                            sx={{ maxWidth: "200px", width: "100%" }}
                            value={status}
                            onChange={(e) => {
                                setStatus(e.target.value)
                            }}
                        >
                            <MenuItem value={""}>
                                All
                            </MenuItem>
                            <MenuItem value={"rejected"}>
                                Rejected
                            </MenuItem>
                            <MenuItem value={"needs_improvement"}>
                                Needs Improvement
                            </MenuItem>
                            <MenuItem value={"approved"}>
                                Approved
                            </MenuItem>
                        </Select>

                    </Stack>

                    {/* <Stack
                        maxWidth={340}
                        alignItems="flex-start"
                        // backgroundColor="#FFFFFF"
                        justifyContent="center"
                    >
                        <Tabs value={tabValue} onChange={handleTabsChange}>
                            <Tab label={`Live (${tabCounts.live})`} />
                            <Tab label={`Upcoming (${tabCounts.upcoming})`} />
                            <Tab label={`Completed (${tabCounts.completed})`} />
                        </Tabs>
                    </Stack> */}
                </Stack>

                {Loading && <LoadingInPage />}
                {!Loading && events?.length === 0 ? (
                    <Stack justifyContent="center" alignItems="center" className="no data">
                        <NoData
                            py={8}
                            src={event_no_data}
                            helperText={
                                <Stack alignItems="center" spacing={1}>
                                    <Typography align="center" color="primary" variant="h3">
                                        No Events Found..!
                                    </Typography>
                                </Stack>
                            }
                        />
                    </Stack>
                ) : (
                    !Loading && (
                        <>
                            <CustomTableContainer>
                                <Table stickyHeader aria-label="sticky table" sx={{ tableLayout: 'auto' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" sx={{ minWidth: '80px' }}>
                                                Sl NO
                                            </TableCell>
                                            {headCells.map((headCell) => (
                                                <TableCell
                                                    key={headCell.id}
                                                    align="center"
                                                    sx={{ minWidth: headCell?.width }}
                                                >
                                                    <h4 style={{ fontWeight: 450, fontSize: '0.95rem' }}>{headCell.label}</h4>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {events?.map((row, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    '&:last-child td, &:last-child th': { border: 0 },
                                                }}
                                            >
                                                <TableCell align="center">{index + 1}</TableCell>

                                                <TableCell align="center" sx={{ '&:hover': { cursor: 'pointer' } }}>
                                                    {row?.vendorName}
                                                </TableCell>

                                                <TableCell align="center" sx={{ '&:hover': { cursor: 'pointer' } }}>
                                                    {row.tracking_id}
                                                </TableCell>

                                                <TableCell align="center" sx={{ '&:hover': { cursor: 'pointer' } }}>
                                                    {row.name}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {(row?.capacity ?? 0) - (row?.remaining_capacity ?? 0)} /{row?.capacity}
                                                </TableCell>

                                                <TableCell align="center" style={{ whiteSpace: 'pre-line' }}>
                                                    <p>
                                                        Start:
                                                        {dayjs(row.event_start).format('DD/MM/YYYY LT')}
                                                    </p>
                                                </TableCell>

                                                <TableCell align="center" style={{ whiteSpace: 'pre-line' }}>
                                                    <p>Ends: {dayjs(row.event_end).format('DD/MM/YYYY LT')}</p>
                                                </TableCell>

                                                <TableCell align="center">{row?.event_type?.name}</TableCell>
                                                <TableCell align="center">{getStatusTextWithColor2(row?.self_event_approval_status)}</TableCell>

                                                <TableCell align="center">
                                                    <Button
                                                        onClick={() =>
                                                            handleEventDetails(
                                                                row._id,
                                                                row.handle,
                                                                row?.event_type?.handle,
                                                                row?.vendor
                                                            )
                                                        }
                                                    >
                                                        <RemoveRedEyeIcon />
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </CustomTableContainer>

                            {/* pagination */}
                            <Stack
                                direction="row"
                                sx={{ width: '100%', p: { xs: 0, sm: 3 } }}
                                alignItems="center"
                                flexWrap="wrap"
                                justifyContent="space-between"
                                gap={1}
                            >
                                <Box
                                    minWidth={220}
                                    width={{ xs: '100%', sm: 'max-content' }}
                                    alignSelf={{ xs: 'center', sm: 'auto' }}
                                >
                                    <Typography
                                        sx={{ textAlign: { xs: 'center', sm: 'normal' } }}
                                        color="primary"
                                        variant="body1"
                                    >{`Showing ${page !== 0 ? page * page_size : 1}  to ${(page + 1) * page_size > total_records ? total_records : (page + 1) * page_size
                                        } of ${total_records} entries`}</Typography>
                                </Box>
                                <Box sx={{ order: { xs: 2, sm: 0 } }} flex={{ xs: 0, sm: 1 }}>
                                    <FormControl sx={{ maxWidth: 'max-content', flexGrow: 1 }} fullWidth>
                                        <Select
                                            className="custom-select"
                                            sx={{
                                                '&.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.custom-select':
                                                {
                                                    height: '37px',
                                                },
                                            }}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={page_size}
                                            onChange={handlePageSize}
                                            color="primary"
                                            renderValue={() => `${page_size} per page`}
                                        >
                                            <MenuItem value={15}>15</MenuItem>
                                            <MenuItem value={25}>25</MenuItem>
                                            <MenuItem value={50}>50</MenuItem>
                                            <MenuItem value={75}>75</MenuItem>
                                            <MenuItem value={100}>100</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>

                                <Pagination page={page} setPage={setPage} totalPages={totalPages} />
                            </Stack>
                        </>
                    )
                )}
            </Stack>
            {
                createEventPopup && (
                    <Radiobutton_dialog
                        heading="Event Creation"
                        subtitle="Choose Event Listing"
                        open={createEventPopup}
                        handleCancel={handleCancel}
                    />
                )
            }
        </Container >
    );
};

export default RequestEvent;
